export enum MainnetChainId {
  Blessnet = 45513,
  Ethereum = 1,
  Arbitrum = 42161,
  Optimism = 10,
  Base = 8453,
}

export enum SepoliaChainId {
  Blessnet = 11145513,
  Ethereum = 11155111,
  Arbitrum = 421614,
  Optimism = 11155420,
  Base = 84532,
}

export enum MainnetWormholeId {
  Ethereum = 2,
  Arbitrum = 23,
  Optimism = 24,
  Base = 30,
}

export enum SepoliaWormholeId {
  Ethereum = 10002,
  Arbitrum = 10003,
  Optimism = 10005,
  Base = 10004,
}

/**
 * Converts a native chain ID to its corresponding Wormhole chain ID
 */
export function getNativeChainIdToWormholeId(chainId: number): number | null {
  // Mainnet mappings
  switch (chainId) {
    case MainnetChainId.Ethereum:
      return MainnetWormholeId.Ethereum;
    case MainnetChainId.Arbitrum:
      return MainnetWormholeId.Arbitrum;
    case MainnetChainId.Optimism:
      return MainnetWormholeId.Optimism;
    case MainnetChainId.Base:
      return MainnetWormholeId.Base;

    // Sepolia testnet mappings
    case SepoliaChainId.Ethereum:
      return SepoliaWormholeId.Ethereum;
    case SepoliaChainId.Arbitrum:
      return SepoliaWormholeId.Arbitrum;
    case SepoliaChainId.Optimism:
      return SepoliaWormholeId.Optimism;
    case SepoliaChainId.Base:
      return SepoliaWormholeId.Base;

    default:
      console.warn(`No Wormhole chain ID mapping found for native chain ID: ${chainId}`);
      return null;
  }
}

export enum MainnetChainExplorer {
  Blessnet = "https://blessnet.calderaexplorer.xyz/tx/",
  Ethereum = "https://etherscan.io/tx/",
  Arbitrum = "https://arbiscan.io/tx/",
  Optimism = "https://optimistic.etherscan.io/tx/",
  Base = "https://basescan.org/tx/",
}

export enum SepoliaChainExplorer {
  Blessnet = "https://blessnet-sepolia-testnet.explorer.caldera.xyz/tx/",
  Ethereum = "https://sepolia.etherscan.io/tx/",
  Arbitrum = "https://sepolia.arbiscan.io/tx/",
  Optimism = "https://sepolia-optimism.etherscan.io/tx/",
  Base = "https://sepolia.basescan.org/tx/",
}
